import UIkit from 'uikit';

const initMainNavigation = () => {
  const navigation = document.getElementById('mobbile-navigation');
  const navigationBackground = document.querySelector('.mobile-navigation-wrapper');
  const navigationToggle = document.getElementById('navigation-toggle');

  if (navigation) {
    UIkit.util.on(navigation, 'show', event => {
      if (event.target === navigation) {
        navigationToggle.classList.add('open');
        navigationBackground.style.display = 'block';
      }
    });

    UIkit.util.on(navigation, 'hide', event => {
      if (event.target === navigation) {
        navigationToggle.classList.remove('open');
        setTimeout(() => {
          navigationBackground.style.display = 'none';
        }, 200)
      }
    });

    // Navigation sublevel handlers
    UIkit.util.on('.sub-nav', 'beforeshow', event => {
      event.target.parentElement.classList.add('has-sublevel-opened');
    });

    UIkit.util.on('.sub-nav', 'hide', event => {
      event.target.parentElement.classList.remove('has-sublevel-opened');
    });
  }
};

export default initMainNavigation;
